var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 64,
    viewBox: "0 0 104 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 63,
    rx: 4.5,
    stroke: "#313131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1463_16589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 40.934L31.8587 23.3023H35.8889L43.7728 40.934H39.4908L33.0426 25.3677H34.6546L28.1813 40.934H24ZM27.9294 37.1558L29.0125 34.0576H38.0802L39.1885 37.1558H27.9294Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7942 41.2363C52.434 41.2363 51.1662 41.018 49.9907 40.5814C48.8321 40.128 47.8246 39.4899 46.9682 38.6671C46.1118 37.8443 45.4401 36.8787 44.9531 35.7704C44.4829 34.6622 44.2478 33.4447 44.2478 32.1181C44.2478 30.7916 44.4829 29.5741 44.9531 28.4659C45.4401 27.3576 46.1118 26.392 46.9682 25.5692C47.8413 24.7464 48.8573 24.1167 50.0159 23.6801C51.1746 23.2267 52.4424 23 53.8194 23C55.3475 23 56.7244 23.2687 57.9502 23.806C59.1929 24.3266 60.234 25.099 61.0736 26.1233L58.454 28.5414C57.8495 27.8529 57.1778 27.3408 56.4389 27.0049C55.7001 26.6523 54.8941 26.476 54.0209 26.476C53.1981 26.476 52.4424 26.6103 51.7539 26.879C51.0654 27.1477 50.4693 27.5339 49.9656 28.0377C49.4618 28.5414 49.0672 29.1375 48.7817 29.826C48.513 30.5145 48.3787 31.2785 48.3787 32.1181C48.3787 32.9578 48.513 33.7218 48.7817 34.4103C49.0672 35.0988 49.4618 35.6949 49.9656 36.1986C50.4693 36.7024 51.0654 37.0886 51.7539 37.3573C52.4424 37.626 53.1981 37.7603 54.0209 37.7603C54.8941 37.7603 55.7001 37.5924 56.4389 37.2566C57.1778 36.9039 57.8495 36.375 58.454 35.6697L61.0736 38.0878C60.234 39.1121 59.1929 39.8929 57.9502 40.4303C56.7244 40.9676 55.3391 41.2363 53.7942 41.2363Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9195 23.3023H80V40.934H75.9195V23.3023ZM67.9096 40.934H63.8291V23.3023H67.9096V40.934ZM76.2218 33.705H67.6074V30.2542H76.2218V33.705Z",
    fill: "#A1A1A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1463_16589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(24 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAch);
export default __webpack_public_path__ + "static/media/ACH.0f6083a5fba03fca959de22ccc00e89c.svg";
export { ForwardRef as ReactComponent };